import {Alert} from "@mui/material";
import React from "react";
import {B2Site} from "./data/client.gen";
import {useLocalization} from "./i18n";

type SiteBookingUnit = B2Site["bookingUnit"];

export function DisplayUnitsCount({unit, count}: { unit: SiteBookingUnit; count: number }) {
	const {t} = useLocalization();
	let counter: string = "";
	switch (unit) {
		case "Days":
			counter = count > 1 ? t("dates.days") : t("dates.day");
			break;
		case "Hours":
			counter = count > 1 ? t("dates.hours") : t("dates.hour");
			break;
	}
	return <span>{count + " " + counter}</span>;
}

export function displayBoxesCount(count: number) {
	const {t} = useLocalization();
	return (count > 1 ? t("boxes.plural") : t("boxes.singular"));
}

export function hasSimplifiedLayout(site: B2Site | undefined) {
	if (site == undefined) return false;
	const boxTypesCount = new Set(site.boxes.map(b => b.type)).size;
	return !site.enabledAdvanceBooking && boxTypesCount === 1;
}

/**
 * Whether online booking should be offered for a site. Fail open on a missing flag so an older backend that
 * doesn't yet send the field keeps sites bookable; an undefined site (still loading) is treated as unavailable.
 */
export function isOnlineBookingAvailable(site: { onlineBookingAvailable?: boolean } | undefined) {
	return site !== undefined && site.onlineBookingAvailable !== false;
}

/**
 * The info notice shown in place of the booking entry point when {@link isOnlineBookingAvailable} is false.
 * Callers keep their own layout wrapper (grid cell, container, …); this is only the shared alert.
 */
export function OnlineBookingUnavailableNotice() {
	const {t} = useLocalization();
	return (
		<Alert severity="info">
			{t("sites.onlineBookingNotAvailable")}
		</Alert>
	);
}
